module.exports = __webpack_public_path__ + "img/banner.7dbc53e3.jpg";